var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Black"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.5742 2.10178C11.4802 2.15663 11.3627 2.27416 11.3079 2.36819L11.21 2.53665V7.41031V12.2879L11.3235 12.4681C11.6212 12.9343 12.3653 12.9343 12.663 12.4681L12.7766 12.2879V7.41031V2.53665L12.6787 2.36819C12.5337 2.12137 12.3066 1.99992 11.9893 1.99992C11.7896 1.99992 11.7034 2.01951 11.5742 2.10178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.11977 4.75808C4.97486 4.82076 4.42263 5.39667 4.07797 5.83937C3.00876 7.2145 2.33512 8.76983 2.06879 10.4858C1.97088 11.1048 1.97871 13.0284 2.08446 13.6592C2.31162 15.05 2.84035 16.4016 3.6119 17.5651C4.03881 18.2116 4.45396 18.7013 5.02577 19.2576C6.43572 20.621 8.02975 21.4554 10.0546 21.8903C10.5598 22 10.5794 22 11.9737 22C13.2857 22 13.415 21.9922 13.834 21.9099C15.855 21.5064 17.5312 20.6405 18.9608 19.2576C20.3041 17.9569 21.248 16.3546 21.7063 14.5916C21.953 13.6357 21.9961 13.2596 22 12.049C22 10.8815 21.9687 10.5681 21.765 9.69834C21.3694 8.00588 20.5 6.39177 19.3172 5.15769C18.9451 4.76983 18.8276 4.70323 18.5221 4.70323C17.9973 4.70323 17.6331 5.15769 17.7506 5.67091C17.7897 5.84329 17.8446 5.92948 18.0913 6.1998C19.3054 7.524 19.9947 8.90304 20.3237 10.6582C20.4216 11.1949 20.4216 12.8678 20.3237 13.4006C20.1631 14.2547 19.9477 14.9207 19.5913 15.665C18.7532 17.4084 17.4255 18.7483 15.6944 19.5945C14.492 20.1861 13.3366 20.4525 11.9933 20.4525C10.6538 20.4525 9.48278 20.1822 8.29215 19.5984C5.86391 18.4074 4.19547 16.1939 3.68632 13.4985C3.56491 12.8717 3.53749 11.5749 3.63149 10.9207C3.88215 9.11851 4.61454 7.59452 5.89132 6.20372C6.21248 5.85505 6.30256 5.64741 6.25556 5.36533C6.2164 5.13418 6.03624 4.88345 5.83649 4.78551C5.63675 4.69148 5.30384 4.67581 5.11977 4.75808Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.7a30aa71f95f903cd59396952d2a1594.svg";
export { ForwardRef as ReactComponent };